<template>
  <div class="configuracoes">
    <header>
      <h2>Configurações do módulo</h2>
      <p>Defina parâmetros globais, permissões e templates de projeto.</p>
    </header>
    <section>
      <h3>Templates de fases</h3>
      <p>Cadastre estruturas padrão de ações e entregas para acelerar o planejamento.</p>
      <div class="painel">
        <label>
          Nome do template
          <input type="text" v-model="template.nome" placeholder="Ex: Implantação rápida" />
        </label>
        <label>
          Descrição
          <textarea v-model="template.descricao" rows="3"></textarea>
        </label>
        <button type="button" @click="salvarTemplate">Salvar template</button>
      </div>
    </section>
    <section>
      <h3>Permissões por perfil</h3>
      <p>Configure quem pode criar, editar ou aprovar projetos.</p>
      <table>
        <thead>
          <tr>
            <th>Perfil</th>
            <th>Criar</th>
            <th>Editar</th>
            <th>Visualizar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="perfil in perfis" :key="perfil.nome">
            <td>{{ perfil.nome }}</td>
            <td><input type="checkbox" v-model="perfil.criar" /></td>
            <td><input type="checkbox" v-model="perfil.editar" /></td>
            <td><input type="checkbox" v-model="perfil.visualizar" /></td>
          </tr>
        </tbody>
      </table>
      <button type="button" class="botao-primario" @click="salvarPermissoes">Salvar permissões</button>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ConfiguracoesGestaoProjetos',
  data () {
    return {
      template: {
        nome: '',
        descricao: ''
      },
      perfis: [
        { nome: 'Administrador estadual', criar: true, editar: true, visualizar: true },
        { nome: 'Gestor municipal', criar: true, editar: true, visualizar: true },
        { nome: 'Consultor', criar: false, editar: true, visualizar: true },
        { nome: 'Observador', criar: false, editar: false, visualizar: true }
      ]
    }
  },
  methods: {
    salvarTemplate () {
      if (!this.template.nome) {
        this.$toasted && this.$toasted.error('Informe o nome do template.')
        return
      }
      this.$toasted && this.$toasted.success('Template salvo localmente. Ajuste a integração conforme necessário.')
      this.template = { nome: '', descricao: '' }
    },
    salvarPermissoes () {
      this.$toasted && this.$toasted.success('Permissões armazenadas localmente. Ajuste a API para persistência definitiva.')
    }
  }
}
</script>

<style scoped>
.configuracoes {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

header h2 {
  margin: 0;
  font-size: 1.8rem;
  color: #0f172a;
}

section {
  background: #ffffff;
  border: 1px solid #d6dde9;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.painel {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.85rem;
  color: #334155;
}

input,
textarea {
  border: 1px solid #c7d2e2;
  border-radius: 8px;
  padding: 8px 10px;
  background: #f8fafc;
  font: inherit;
}

button {
  border-radius: 8px;
  border: 1px solid #1d4ed8;
  background: #1d4ed8;
  color: #ffffff;
  padding: 8px 14px;
  cursor: pointer;
  font-weight: 600;
}

.botao-primario {
  background: #0f766e;
  border-color: #0f766e;
  color: #ffffff;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
}

th {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #64748b;
}
</style>
